module.exports = __webpack_public_path__ + "media/28 melt away.55b4e6ab.mp3";